import { UserType } from '../src/types/user';

export const renderFullName = ({
	firstName,
	lastName,
}: {
	firstName?: UserType['firstName'];
	lastName: UserType['lastName'];
}) => `${firstName ?? ''} ${lastName}`.trim();
